<template>
    <div>
        <div class="row">
            <div class="col-xl-4 col-lg-6 col-xs-12">
                <form-element>
                    <label for="title">{{resource('PushNotificationCreationModel_Title_DisplayName')}}</label>
                    <input v-model="$v.model.title.$model" id="title" type="text" class="form-control" />

                    <template v-slot:errors v-if="$v.model.title.$dirty && $v.model.title.$invalid">
                        <required-error-message :field-name="resource('PushNotificationCreationModel_Title_DisplayName')" v-if="!$v.model.title.required" />
                        <max-length-error-message :field-name="resource('PushNotificationCreationModel_Title_DisplayName')" :max-length="rules.title.maxLength" v-if="!$v.model.title.maxLength" />
                    </template>
                </form-element>

                <form-element>
                    <label for="message">{{resource('PushNotificationCreationModel_Message_DisplayName')}}</label>
                    <textarea v-model="$v.model.message.$model" id="message" class="form-control"  />

                    <template v-slot:errors v-if="$v.model.message.$dirty && $v.model.message.$invalid">
                        <required-error-message :field-name="resource('PushNotificationCreationModel_Message_DisplayName')" v-if="!$v.model.message.required" />
                        <max-length-error-message :field-name="resource('PushNotificationCreationModel_Message_DisplayName')" :max-length="rules.message.maxLength" v-if="!$v.model.message.maxLength" />
                    </template>
                </form-element>
            </div>
            <div class="col-xl-4 col-lg-6 col-xs-12">
                <form-element icon="far fa-bell" :labelSize="4">
                    <label for="type">{{resource('PushNotificationCreationModel_Type_DisplayName')}}</label>
                    <v-select id="type"
                              v-model="model.type"
                              :options="types"
                              :clearable="false"
                              :selectOnTab="true"
                              class="form-control"
                    />
                </form-element>

                <form-element icon="far fa-clock" :labelSize="4">
                    <label for="expiretime">{{resource('PushNotificationCreationModel_ExpiresInMinutes_DisplayName')}}</label>
                    <input v-model.number="$v.model.expiresInMinutes.$model" id="expiretime" type="number" min="1" class="form-control" />

                    <template v-slot:errors v-if="$v.model.expiresInMinutes.$dirty && $v.model.expiresInMinutes.$invalid">
                        <required-error-message :field-name="resource('PushNotificationCreationModel_ExpiresInMinutes_DisplayName')" v-if="!$v.model.expiresInMinutes.required" />
                        <min-value-error-message :field-name="resource('PushNotificationCreationModel_ExpiresInMinutes_DisplayName')" :min-value="rules.expiresInMinutes.minValue" v-if="!$v.model.expiresInMinutes.minValue" />
                    </template>
                </form-element>
            </div>
        </div>
        
        <div class="row form-group">
            <div class="col-xl-8 col-md-12">
                <button class="btn btn-primary pull-right" @click="sendNotification" :class="{ disabled: !isValid }">
                    {{resource('Button_Create')}}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import api from '../api';
    import types from "../../../Util/SignalR/NotificationHub/push-notification-types";

    import loader from "../../../Util/loader";
    import {
        bootstrapDangerGrowl as errorGrowl, 
        bootstrapSuccessGrowl as successGrowl
    } from "../../../Util/growler";

    import { required, maxLength, minValue } from 'vuelidate/lib/validators';
    import {validationMixin} from 'vuelidate';
    import resourceMixin from "../../../Util/Mixins/resources";
    
    import InputGroup from "../../../Components/Inputs/InputGroup.vue";
    import FormElement from "./Editor/FormElement.vue";
    import RequiredErrorMessage from "../../../Components/Errors/RequiredErrorMessage.vue";
    import MaxLengthErrorMessage from "../../../Components/Errors/MaxLengthErrorMessage.vue";
    import MinValueErrorMessage from "../../../Components/Errors/MinValueErrorMessage.vue";
    
    import VSelect from 'vue-select';
    
    const rules = {
        title: {
            maxLength: 255
        },
        text: {
            maxLength: 2000
        },
        expiresInMinutes: {
            minValue: 1
        }
    };
    
    export default {
        name: 'push-notifications-create',
        mixins: [resourceMixin, validationMixin],
        components: {
            RequiredErrorMessage,
            MaxLengthErrorMessage,
            MinValueErrorMessage,
            InputGroup,
            FormElement,
            VSelect
        },
        created() {
            //Simply take our type names for the time being
            this.types = Object.values(types).map(t => t.name);
            
            this.resetModel();
        },
        methods: {
            sendNotification(){
                const vm = this;
                
                if(!vm.isValid){
                    //Mark all fields as dirty to display their errors
                    vm.$v.model.$touch();
                    return;
                }
                
                loader.show();
                
                api.sendPushNotification(vm.model).then(
                    () => {
                        vm.$emit('notification-created');
                        
                        //Only reset our model on success
                        vm.resetModel();
                        loader.hide();
                        
                        successGrowl(vm.resource('PushNotificationsService_NotificationCreated_SuccessMessage'));
                    },
                    (err) => {
                        loader.hide();
                        
                        errorGrowl(err);
                    }
                );
            },
            resetModel() {
                //Reset our model
                this.model = {
                    title: '',
                    message: '',
                    
                    //Take first encountered type as default
                    type: this.types[0],
                    expiresInMinutes: 5
                };
                
                //And clear form validation
                this.$v.model.$reset();
            }
        },
        validations: {
            model: {
                title: {
                    required,
                    maxLength: maxLength(rules.title.maxLength)
                },
                message: {
                    required,
                    maxLength: maxLength(rules.text.maxLength)
                },
                expiresInMinutes: {
                    minValue: minValue(rules.expiresInMinutes.minValue),
                    required
                }
            }
        },
        computed: {
            isValid(){
                return !this.$v.model.$invalid;
            }
        },
        data: () => ({
            rules: rules,
            types: [],
            
            model: undefined
        })
    }
</script>